// PunchedAttendanceFilterTailwind.jsx
import React from "react";
import PropTypes from "prop-types";

export default function PunchedAttendanceFilterTailwind({
  title,
  subtitle,
  states = [],
  divisions = [],
  months = [],
  years = [],
  selectedState,
  setSelectedState,
  selectedDivision,
  setSelectedDivision,
  selectedMonth,
  setSelectedMonth,
  selectedYear,
  setSelectedYear,
  mode = "monthYearSplit",
  employees = [],
  selectedEmployee,
  setSelectedEmployee,
  monthYearOptions = [],
  selectedMonthYear,
  setSelectedMonthYear,
  chemists = [],
  selectedChemist,
  setSelectedChemist,
  startDate,           // 👈 FIX ADDED
  setStartDate,        // 👈 FIX ADDED
  endDate,             // 👈 FIX ADDED
  setEndDate,          // 👈 FIX ADDED
  handleGoClick,
  isLoading = false,
  error = null,
  CustomButton = null,
  Loader = null,
}) {
  return (
    <div className="w-full p-4 border-2 border-gray-300 rounded-lg bg-gray-50 box-border">
      <h1 className="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-4">
        <span className="text-blue-700">{title}</span>
        <span className="text-blue-500">{subtitle}</span>
      </h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-4 gap-x-0 items-center justify-items-center mb-4">
        <div className="flex items-center w-full justify-center lg:-mr-6">
          <label className="hidden lg:block w-32 text-right pr-2 font-medium text-gray-800">
            State
          </label>

          <label className="lg:hidden block w-full text-left mb-1 font-medium text-gray-800">
            State
          </label>

          <select
            value={selectedState ?? ""}
            onChange={(e) =>
              setSelectedState && setSelectedState(e.target.value)
            }
            className="px-3 py-2 border border-gray-300 rounded-md bg-white text-sm w-full lg:w-[260px] appearance-none"
          >
            <option value="">Select State</option>
            {states.map((s) => (
              <option key={s.id} value={s.id}>
                {s.name}
              </option>
            ))}
          </select>
        </div>

        <div className="flex items-center w-full justify-center lg:-ml-6">
          <label className="hidden lg:block w-32 text-right pr-2 font-medium text-gray-800">
            Division
          </label>

          <label className="lg:hidden block w-full text-left mb-1 font-medium text-gray-800">
            Division
          </label>
<select
  value={selectedDivision}
  onChange={(e) => setSelectedDivision(e.target.value)}
  disabled={!selectedState}
  className="px-3 py-2 border border-gray-300 rounded-md bg-white text-sm w-full lg:w-[260px]"
>
  <option value="All">All</option>
  {divisions.map((d) => (
    <option key={d.id} value={d.id}>
      {d.name}
    </option>
  ))}
</select>

        </div>
      </div>

      {mode === "monthYearSplit" && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-4 gap-x-0 items-center justify-items-center">
          <div className="flex items-center w-full justify-center lg:-mr-6">
            <label className="hidden lg:block w-32 text-right pr-2 font-medium text-gray-800">
              Month
            </label>

            <label className="lg:hidden block w-full text-left mb-1 font-medium text-gray-800">
              Month
            </label>

            <select
              value={selectedMonth ?? ""}
              onChange={(e) =>
                setSelectedMonth &&
                setSelectedMonth(parseInt(e.target.value || "0", 10))
              }
              className="px-3 py-2 border border-gray-300 rounded-md bg-white text-sm w-full lg:w-[260px] appearance-none"
            >
              <option value="">Select Month</option>
              {months.map((m) => (
                <option key={m.value} value={m.value}>
                  {m.label}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center w-full justify-center lg:-ml-6">
            <label className="hidden lg:block w-32 text-right pr-2 font-medium text-gray-800">
              Year
            </label>

            <label className="lg:hidden block w-full text-left mb-1 font-medium text-gray-800">
              Year
            </label>

            <select
              value={selectedYear ?? ""}
              onChange={(e) =>
                setSelectedYear &&
                setSelectedYear(parseInt(e.target.value || "0", 10))
              }
              className="px-3 py-2 border border-gray-300 rounded-md bg-white text-sm w-full lg:w-[260px] appearance-none"
            >
              <option value="">Select Year</option>
              {years.map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}
{mode === "employeeMonthYearCompact" && (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-4 gap-x-0 items-center justify-items-center">

    {/* Employee */}
    <div className="flex items-center w-full justify-center lg:-mr-6">
      <label className="hidden lg:block w-32 text-right pr-2 font-medium text-gray-800">
        Employee
      </label>

      <label className="lg:hidden block w-full text-left mb-1 font-medium text-gray-800">
        Employee
      </label>

      <select
        value={selectedEmployee ?? ""}
        onChange={(e) => setSelectedEmployee && setSelectedEmployee(e.target.value)}
        disabled={!selectedState}
        className="px-3 py-2 border border-gray-300 rounded-md bg-white text-sm w-full lg:w-[260px]"
      >
        {employees.map((emp) => (
          <option key={emp.id} value={emp.id}>
            {emp.id === "All"
              ? "All"
              : `${emp.first_name} ${emp.last_name} | ${emp.designation} | ${emp.headquarter_name} | ${emp.division} | ${emp.state_name}`}
          </option>
        ))}
      </select>
    </div>

    {/* Chemist Dropdown */}
    <div className="flex items-center w-full justify-center lg:-ml-6">
      <label className="hidden lg:block w-32 text-right pr-2 font-medium text-gray-800">
        Chemist
      </label>

      <label className="lg:hidden block w-full text-left mb-1 font-medium text-gray-800">
        Chemist
      </label>

      <select
        value={selectedChemist ?? "All"}
        onChange={(e) => setSelectedChemist?.(e.target.value)}
        disabled={!selectedEmployee}
        className="px-3 py-2 border border-gray-300 rounded-md bg-white text-sm w-full lg:w-[260px]"
      >
      <option value="All">All</option>
      {chemists.map((c) => (
        <option key={c.id} value={c.id}>
          {c.chemist_name || c.name}
          {c.city ? ` | ${c.city}` : ""}
          {c.route_name ? ` | ${c.route_name}` : ""}
          {c.area_name ? ` | ${c.area_name}` : ""}
        </option>
      ))}

      </select>
    </div>

    {/* Month */}
    <div className="flex items-center w-full justify-center lg:-mr-6">
      <label className="hidden lg:block w-32 text-right pr-2 font-medium text-gray-800">
        Month
      </label>

      <label className="lg:hidden block w-full text-left mb-1 font-medium text-gray-800">
        Month
      </label>

      <select
        value={selectedMonth ?? ""}
        onChange={(e) => setSelectedMonth?.(e.target.value)}
        className="px-3 py-2 border border-gray-300 rounded-md bg-white text-sm w-full lg:w-[260px]"
      >
        <option value="">Select Month</option>
        {months.map((m) => (
          <option key={m.value} value={m.value}>
            {m.label}
          </option>
        ))}
      </select>
    </div>

    {/* Year */}
    <div className="flex items-center w-full justify-center lg:-ml-6">
      <label className="hidden lg:block w-32 text-right pr-2 font-medium text-gray-800">
        Year
      </label>

      <label className="lg:hidden block w-full text-left mb-1 font-medium text-gray-800">
        Year
      </label>

      <select
        value={selectedYear ?? ""}
        onChange={(e) => setSelectedYear?.(e.target.value)}
        className="px-3 py-2 border border-gray-300 rounded-md bg-white text-sm w-full lg:w-[260px]"
      >
        <option value="">Select Year</option>
        {years.map((y) => (
          <option key={y} value={y}>
            {y}
          </option>
        ))}
      </select>
    </div>

  </div>
)}


      {mode === "stateDivisionMonthYear" && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-4 gap-x-0 items-center justify-items-center">
          <div className="flex items-center w-full justify-center lg:-mr-6">
            <label className="hidden lg:block w-32 text-right pr-2 font-medium text-gray-800">
              Month / Year
            </label>

            <label className="lg:hidden block w-full text-left mb-1 font-medium text-gray-800">
              Month / Year
            </label>

            <select
              value={selectedMonthYear ?? ""}
              onChange={(e) =>
                setSelectedMonthYear && setSelectedMonthYear(e.target.value)
              }
              className="px-3 py-2 border border-gray-300 rounded-md bg-white text-sm w-full lg:w-[260px] appearance-none"
            >
              {monthYearOptions.map((option, idx) => (
                <option key={idx} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="hidden lg:block" />
        </div>
      )}

{mode === "selectChemist" && (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-4 gap-x-0 items-center justify-items-center">

    {/* Employee Dropdown */}
    <div className="flex items-center w-full justify-center lg:-mr-6">
      <label className="hidden lg:block w-32 text-right pr-2 font-medium text-gray-800">
        Employee
      </label>

      <label className="lg:hidden block w-full text-left mb-1 font-medium text-gray-800">
        Employee
      </label>

      <select
        value={selectedEmployee ?? "All"}
        onChange={(e) => setSelectedEmployee?.(e.target.value)}
        disabled={!selectedState}
        className="px-3 py-2 border border-gray-300 rounded-md bg-white text-sm w-full lg:w-[260px]"
      >
        <option value="All">All</option>
        {employees.map((emp) => (
          <option key={emp.id} value={emp.id}>
            {`${emp.first_name} ${emp.last_name} | ${emp.designation} | ${emp.headquarter_name} | ${emp.division} | ${emp.state_name}`}
          </option>
        ))}
      </select>
    </div>

    {/* 📅 START DATE */}
    <div className="flex items-center w-full justify-center lg:-ml-6">
      <label className="hidden lg:block w-32 text-right pr-2 font-medium text-gray-800">
        Start Date
      </label>

      <label className="lg:hidden block w-full text-left mb-1 font-medium text-gray-800">
        Start Date
      </label>

      <input
        type="date"
        value={startDate}
        onChange={(e) => setStartDate?.(e.target.value)}
        className="px-3 py-2 border border-gray-300 rounded-md bg-white text-sm w-full lg:w-[260px]"
      />
    </div>

    {/* 📅 END DATE */}
    <div className="flex items-center w-full justify-center lg:-mr-6">
      <label className="hidden lg:block w-32 text-right pr-2 font-medium text-gray-800">
        End Date
      </label>

      <label className="lg:hidden block w-full text-left mb-1 font-medium text-gray-800">
        End Date
      </label>

      <input
        type="date"
        value={endDate}
        min={startDate}
        onChange={(e) => setEndDate?.(e.target.value)}
        className="px-3 py-2 border border-gray-300 rounded-md bg-white text-sm w-full lg:w-[260px]"
      />
    </div>

  </div>
)}


      <div className="flex justify-center mt-4">
        {CustomButton ? (
          <CustomButton
            variant="go"
            onClick={handleGoClick}
            disabled={isLoading}
          >
            {isLoading ? (Loader ? <Loader /> : "Loading...") : "GO"}
          </CustomButton>
        ) : (
          <button
            onClick={handleGoClick}
            disabled={isLoading}
            type="button"
            className="relative bg-green-600 hover:bg-green-700 disabled:opacity-60 text-white font-semibold rounded-full px-4 py-2 w-24 shadow-md"
          >
            {isLoading ? "Loading..." : "GO"}
          </button>
        )}
      </div>

      {error && <div className="text-center text-red-600 mt-3">{error}</div>}
    </div>
  );
}

PunchedAttendanceFilterTailwind.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  states: PropTypes.array,
  divisions: PropTypes.array,
  months: PropTypes.array,
  years: PropTypes.array,
  selectedState: PropTypes.any,
  setSelectedState: PropTypes.func,
  selectedDivision: PropTypes.any,
  setSelectedDivision: PropTypes.func,
  selectedMonth: PropTypes.any,
  setSelectedMonth: PropTypes.func,
  selectedYear: PropTypes.any,
  setSelectedYear: PropTypes.func,
  handleGoClick: PropTypes.func,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  CustomButton: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  Loader: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  mode: PropTypes.oneOf([
    "monthYearSplit",
    "employeeMonthYearCompact",
    "employeeChemistMonthYear",
    "stateDivisionMonthYear",
    "selectChemist"
  ]),
  employees: PropTypes.array,
  selectedEmployee: PropTypes.any,
  setSelectedEmployee: PropTypes.func,
  chemists: PropTypes.array,
  selectedChemist: PropTypes.any,
  setSelectedChemist: PropTypes.func,
  startDate: PropTypes.string,
  setStartDate: PropTypes.func,
  endDate: PropTypes.string,
  setEndDate: PropTypes.func,
  monthYearOptions: PropTypes.array,
  selectedMonthYear: PropTypes.any,
  setSelectedMonthYear: PropTypes.func,
};
